import { useEffect } from "react";
import { doc, setDoc, increment, addDoc, collection } from "firebase/firestore";
import { db } from "../firebase";

function VisitorTracker() {
  useEffect(() => {
    const trackVisitor = async () => {
      try {
        // Detect device
        const userAgent = navigator.userAgent;
        let device = "desktop";

        if (/mobile/i.test(userAgent)) {
          device = "mobile";
        } else if (/tablet|ipad/i.test(userAgent)) {
          device = "tablet";
        }

        // 1. Update portfolio views & device count immediately (resilient with setDoc merge)
        try {
          await setDoc(
            doc(db, "analytics", "portfolioViews"),
            { count: increment(1) },
            { merge: true }
          );
          await setDoc(
            doc(db, "analytics", "devices"),
            { [device]: increment(1) },
            { merge: true }
          );
        } catch (analyticsErr) {
          console.error("Analytics counter error:", analyticsErr);
        }

        // 2. Get visitor location info safely
        let country = "Unknown";
        let company = "Unknown Network";

        try {
          const response = await fetch("https://ipapi.co/json/");
          if (response.ok) {
            const data = await response.json();
            if (data && !data.error) {
              country = data.country_name || "Unknown";
              company = data.org || "Unknown Network";
            }
          }
        } catch (geoErr) {
          console.warn("ipapi fetch failed, trying fallback:", geoErr);
          try {
            const fallbackRes = await fetch("https://api.country.is/");
            if (fallbackRes.ok) {
              const fbData = await fallbackRes.json();
              if (fbData && fbData.country) {
                country = fbData.country;
              }
            }
          } catch (_) {}
        }

        // 3. Update country count
        if (country && country !== "Unknown") {
          try {
            await setDoc(
              doc(db, "visitors", "visitorData"),
              {
                countries: {
                  [country]: increment(1)
                }
              },
              { merge: true }
            );
          } catch (cErr) {
            console.error("Country count error:", cErr);
          }
        }

        // 4. Add visitor timeline entry
        try {
          await addDoc(
            collection(db, "visitors", "visitorData", "timeline"),
            {
              country: country,
              device: device,
              company: company,
              time: new Date().toLocaleString(),
              timestamp: Date.now()
            }
          );
        } catch (tErr) {
          console.error("Timeline add error:", tErr);
        }

      } catch (error) {
        console.log("Visitor tracking error:", error);
      }
    };

    trackVisitor();
  }, []);

  return null;
}

export default VisitorTracker;